<template>
  <div
    :id="`fpp-container-${content.id}`"

    class="portal shadow-lg dynamic-component"
  >
    <div class="portal-header relative">
      <h2 class="text-typeLight mb-0 pb-0">
        {{ content.title }}
      </h2>
      <p
        v-if="content.subtitle"
        class="portal-subtitle text-typeLight opacity-90 mt-1 mb-0"
      >
        {{ content.subtitle }}
      </p>
      <p
        v-if="content.contextLine"
        class="portal-context text-typeLight opacity-75 mt-1 mb-0"
      >
        {{ content.contextLine }}
      </p>
      <div
        class="close cursor-pointer"
        @click="close"
      >
        <i class="fa fa-times-circle text-typeLight" />
      </div>
    </div>
    <div
      class="content"
      @click.stop
    >
      <!-- Render dynamic component directly -->
      <component
        :is="content.component"
        v-bind="content.props"
        @action-complete="close"
      />
    </div>
  </div>
</template>

<script>

import {v4 as uuidv4} from "uuid";
import {mapState} from "vuex";

export default {
  props: {
    content: {
      type: Object,
      required: true
    },
    dynamicRender: {
      type: Function,
      default: null
    },
    removeById: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      componentContainerId: uuidv4(),
      instance: null
    };
  },
  computed: {
    ...mapState({
      savedChangesTracker: state => state.webGeneral.savedChangesTracker,
    }),
  },
  mounted() {
    this.$nextTick(()=>{
      setTimeout(()=>{
        document.getElementById(`fpp-container-${this.content.id}`).classList.add("slide-in");
      }, 250);
    });
    document.body.classList.add("no-scroll");
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleEscape);
    if (this.instance) {
      this.instance.$destroy();
      this.instance = null;
    }
  },
  methods: {
    close() {
      document.body.classList.remove("no-scroll");
      const panel = document.getElementById(`fpp-container-${this.content.id}`);
      if (panel) {
        panel.classList.remove('slide-in');
      }
      // remove the container after animation
      setTimeout(() => {
        this.removeById(`${this.content.id}`);
      }, 250);
    },
    handleEscape(e){
      if (e.key === 'Escape' && !this.savedChangesTracker) {
        this.close();
      }
    }
  },
  events: {
    destroyAllDynamics(){
      setTimeout(() => {
        this.close(); // Destroy parent component
      }, 250);
    }
  }
};
</script>

<style lang="scss" scoped>
.portal {
  @apply bg-gray-100;
  position: fixed;
  top: -100%;
  left: 0;
  right: 0;
  height: 100%;
  //bottom: 0;
  z-index: 99;
  margin: 0;
  overflow: hidden;
  transition-delay: 1s;
  transition: top 0.4s ease-in-out;
  @media (min-width: 768px) {
    margin: 0;
  }
  .portal-header {
    @apply bg-primary;
    padding: 20px;
    padding-right: 50px;
  }
  .portal-subtitle {
    @apply text-base font-semibold;
  }
  .portal-context {
    @apply text-sm;
  }
  &.slide-in {
    transition: top 0.4s ease-in-out;
    top: 0;
  }
  div.content {
    height: calc(100% - 50px);
    overflow-y: scroll;
    padding: 20px 20px 60px;
  }
}
.close {
  position: absolute;
  top: 22px;
  right: 20px;
  font-size: 20px;
}
</style>
